import { Box, CircularProgress, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import STRING_KEYS from '../../../../../../language/keys';
import { ProgressBar } from '../../ProgressBar';
import { MatchEngineWorkflowStatusEnum } from '../../../../../../enums/match-engine-workflow-status.enum';
import { style } from './style';

type RunStatusInProgressProps = {
  progress: number,
  matchEngineStatus: MatchEngineWorkflowStatusEnum,
}
export const RunStatusInProgress = ({
  progress,
  matchEngineStatus,
}:RunStatusInProgressProps):JSX.Element => {
  const { t: translate } = useTranslation();

  const getText = () => {
    if (!matchEngineStatus || matchEngineStatus === MatchEngineWorkflowStatusEnum.Scheduled) {
      return translate(STRING_KEYS.PROGRESS_STATUSES.PENDING);
    }

    return translate(STRING_KEYS.PROGRESS_RUNNING_MESSAGE, { count: progress });
  };

  return (
    <Box>
      <ProgressBar
        value={ progress }
        color="primary.text"
      />
      <Box sx={ style.box.sx }>
        <CircularProgress size={ 26 } />
        <Typography variant="overline" sx={ style.errorMessage.sx }>
          {getText()}
        </Typography>
      </Box>
    </Box>
  );
};
